export const erc20Abi = require("./erc20.json"); 
export const receiptBridgeAbi = require("./receiptBridge.json"); 
